import { render } from "./VsCollapseItem.vue?vue&type=template&id=2187a422"
import script from "./VsCollapseItem.vue?vue&type=script&lang=js"
export * from "./VsCollapseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__